import EventGenerateLayout from '@/components/Event/EventGenerateLayout';

export const unstable_settings = {
  anchor: 'index',
};

export default function PrivateEventGenerateLayoutRoute() {
  return <EventGenerateLayout />;
}
